import { yupResolver } from '@hookform/resolvers/yup';
import Flex from 'components/common/Flex';
import LoadingButton from 'components/common/LoadingButton';
import { FormProvider, RHFSelect, RHFDatePicker } from 'components/common/form';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { useHospitals } from 'hooks/useBeneficiaries';

const schema = Yup.object().shape({
  hospital: Yup.string().required('Required Field'),
  startDate: Yup.string().required('Required Field'),
  endDate: Yup.string().nullable()
});

function AddHospitalModal({ show, onSubmit, isSubmitLoading, onHide, title }) {
  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      hospital: '',
      startDate: '',
      endDate: null
    },
    resolver: yupResolver(schema)
  });

  const { handleSubmit } = methods;
  const { hospitals } = useHospitals();

  const hospitalOptions = useMemo(() => {
    return (
      hospitals?.map(item => ({
        label: item.name,
        value: item.id
      })) || []
    );
  }, [hospitals]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton className="modal-header">
        <Modal.Title className="modal-header-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pb-3 ps-3 pe-3">
        <FormProvider
          methods={methods}
          onSubmit={handleSubmit(onSubmit)}
          loading={isSubmitLoading}
        >
          <Flex gap={3} direction="column" className="mt-3">
            <Row>
              <Col md={12}>
                <RHFSelect
                  name="hospital"
                  label="Hospital"
                  options={hospitalOptions}
                  required
                />
              </Col>
              <Col md={6}>
                <RHFDatePicker
                  name="startDate"
                  label="Start Date"
                  required={true}
                  max={false}
                />
              </Col>
              <Col md={6}>
                <RHFDatePicker name="endDate" label="End Date" max={false} />
              </Col>
            </Row>
            <LoadingButton
              style={{ width: '100%', color: 'white' }}
              variant="primary"
              loading={isSubmitLoading}
              disabled={isSubmitLoading}
              className="w-100"
              type="submit"
            >
              Save
            </LoadingButton>
          </Flex>
        </FormProvider>
      </Modal.Body>
    </Modal>
  );
}

AddHospitalModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  title: PropTypes.string,
  onSubmit: PropTypes.func,
  isSubmitLoading: PropTypes.bool
};

export default AddHospitalModal;
